<script setup lang="ts">
const widgetRef = ref<HTMLElement | null>(null)

onMounted(() => {
  const w = window as any
  // Lo script Trustpilot resta in pagina anche se il consenso Marketing viene revocato:
  // senza questo controllo il widget ricomparirebbe quando il componente viene ricreato
  if (w.Trustpilot && w.Cookiebot?.consent?.marketing) {
    w.Trustpilot.loadFromElement(widgetRef.value, true)
  }
})
</script>

<template>
  <!-- TrustBox widget - Mini -->
  <div
    ref="widgetRef"
    class="trustpilot-widget"
    data-locale="it-IT"
    data-template-id="53aa8807dec7e10d38f59f32"
    data-businessunit-id="5c417fcf54f3fa00016c0093"
    data-style-height="150px"
    data-style-width="100%"
    data-theme="dark"
    data-token="7aa1841a-ac3b-40d4-9df6-3b119d7230ba"
  >
    <!-- Fallback nascosto: senza consenso Marketing il widget non viene caricato e non mostriamo nulla -->
    <a class="hidden" href="https://it.trustpilot.com/review/risparmiatu.com" target="_blank" rel="noopener">Trustpilot</a>
  </div>
  <!-- End TrustBox widget -->
</template>
